
import { Options, prop, Vue } from "vue-class-component";
import { flags } from "@/feature-flags";
import { SttAdjustmentRule } from "@/domain/entities/ShipmentBooking";
import { ConfigValidationForm } from "@/domain/entities/CreateBookingV3";
import UploadImageTiny from "@/app/ui/components/upload-image-tiny/index.vue";

class Props {
  modelValue = prop<any>({
    required: true
  });
  showViewAdjustment = prop<boolean>({
    default: true,
    type: Boolean
  });
  defaultOpened = prop<boolean>({
    default: true,
    type: Boolean
  });
  title = prop<string>({
    default: "",
    type: String
  });
  watermark = prop<string>({
    default: "",
    type: String
  });
  photoGuides = prop<any>({
    default: null,
    type: Array
  });
  configPiece = prop<SttAdjustmentRule>({
    default: () => new SttAdjustmentRule(),
    type: Object
  });
  marginBottom = prop<boolean>({
    default: true,
    type: Boolean
  });
}

@Options({
  name: "SectionUploadPhotoForWeightAdjustmentV4",
  emits: [
    "onUploadImage",
    "onDeleteImage",
    "update:showViewAdjustment",
    "update:modelValue"
  ],
  components: {
    UploadImageTiny
  },
  watch: {
    showViewAdjustment: {
      handler(val: boolean) {
        this.isOpened = val;
      },
      immediate: true
    },
    computedPhotoGuides: {
      handler(val: any[]) {
        if (!this.photoGuides) {
          this.proofPhotos = [...val];
        }
      },
      immediate: true
    }
  }
})
export default class SectionUploadPhotoForWeightAdjustmentV4 extends Vue.with(
  Props
) {
  isShaking = false;
  isOpened = true;
  proofPhotos: any[] = [];
  attachmentImage: any = [];

  mounted() {
    this.isOpened = this.defaultOpened;
  }

  get computedPhotoGuides(): any[] {
    if (this.photoGuides && this.photoGuides.length) {
      return this.photoGuides;
    }
    return [
      {
        source: "guide-photo-one",
        desc: this.$t("bookingV4.goods.uploadWeight.guideScalePhoto") as string
      },
      {
        source: "guide-photo-two",
        desc: this.$t(
          "bookingV4.goods.uploadWeight.guidePackageIdentityPhoto"
        ) as string
      }
    ];
  }

  get getRulePieceDisabled(): boolean {
    return this.configPiece.rule.includes(ConfigValidationForm.NON_EDITABLE);
  }

  get maxPhoto(): number {
    return flags.flag_max_photo_for_weight_adjustment.getValue();
  }

  toggleGuide(): void {
    this.isOpened = !this.isOpened;
    this.$emit("update:showViewAdjustment", this.isOpened);
  }

  onAddImage(): void {
    this.proofPhotos.push({
      source: "",
      desc: this.$t("bookingV4.goods.uploadWeight.additionalPhoto") as string
    });
    this.$emit("update:modelValue", this.attachmentImage);
  }

  onUpload(file: any): void {
    this.$emit("update:modelValue", this.attachmentImage);
    if (file.file) this.$emit("onUploadImage", file);
  }

  onRemove(index: number): void {
    this.deleteFiles(index);
    this.$emit("onDeleteImage", index);
  }

  deleteFiles(index: number): void {
    this.attachmentImage[index] = "";
    this.$emit("update:modelValue", this.attachmentImage);
  }

  onClickAccordion(): void {
    if (!this.isOpened) {
      this.isOpened = true;
      this.$emit("update:showViewAdjustment", true);
    }
    const element = document.getElementById("section-upload-photo");
    element?.scrollIntoView({ behavior: "smooth" });
    this.isShaking = true;
    setTimeout(() => {
      this.isShaking = false;
    }, 2000);
  }
}
